import { render } from "./ViewNotFound.vue?vue&type=template&id=1900f921&ts=true"
import script from "./ViewNotFound.vue?vue&type=script&lang=ts"
export * from "./ViewNotFound.vue?vue&type=script&lang=ts"

import "./ViewNotFound.vue?vue&type=style&index=0&id=1900f921&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__